import {
  type BenchmarkIndicatorRow,
  UniversalBenchmarksIndicator,
} from "@features/universal-benchmarks";
import Spinner from "@shared/spinner";

interface Props {
  universalBenchmarks: { status: string } | null;
  benchmarkItemName: string;
  benchmarkIndicatorRows: BenchmarkIndicatorRow[];
}

export const BenchmarksIndicator = ({
  universalBenchmarks,
  benchmarkItemName,
  benchmarkIndicatorRows,
}: Props) => {
  return (
    <>
      {universalBenchmarks?.status === "loading" && (
        <Spinner colorClassname="w-3 h-3 text-cosmic text-xxs" />
      )}
      {benchmarkIndicatorRows.length > 0 && (
        <UniversalBenchmarksIndicator
          benchmarkItemName={benchmarkItemName}
          benchmarkIndicatorRows={benchmarkIndicatorRows}
        />
      )}
    </>
  );
};
